module.exports = __webpack_public_path__ + "static/img/Joe.f906fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Joe.png
// module id = td2b
// module chunks = 34